import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { settings } from "@/settings";

const AZURE_APP_CLIENT_ID = settings.azureAppClientId;
const AZURE_APP_TENANT_ID = settings.azureAppTenantId;

// MSAL configuration
const configuration: Configuration = {
  auth: {
    authority: `https://login.microsoftonline.com/${AZURE_APP_TENANT_ID}`,
    clientId: AZURE_APP_CLIENT_ID,
    redirectUri: `${window.location.origin}/redirect`,
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const pca = new PublicClientApplication(configuration);
export const scope = `api://${AZURE_APP_CLIENT_ID}/user_impersonation`;
